export default "__VITE_ASSET__DAyLdEhe__"